module.exports = __webpack_public_path__ + "static/media/newCall.c1c735c6.mp3";